if (!customElements.get('cookie-banner')) {
  customElements.define(
    'cookie-banner',
    class CookieBanner extends ModalElement {
      constructor() {
        super();
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get acceptButton() {
        return this.querySelector('button[name="accept"]');
      }
    
      get declineButton() {
        return this.querySelector('button[name="decline"]');
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
    
        this.on(document, 'visitorConsentCollected', () => {
          clearTimeout(this.showTimer);
          this.hide();
        });

        if (window.Shopify.customerPrivacy) {
          this.onConsentLibraryLoaded();
          return;
        }
    
        window.Shopify.loadFeatures([{
          name: 'consent-tracking-api',
          version: '0.2'
        }], this.onConsentLibraryLoaded.bind(this));
      }

      shouldShowBanner() {
        const privacy = window.Shopify.customerPrivacy;
        if (!privacy) return false;

        const consent = privacy.currentVisitorConsent();
        const hasConsent = ['analytics', 'marketing', 'preferences'].some(
          (purpose) => consent[purpose] === 'yes' || consent[purpose] === 'no'
        );

        return !hasConsent;
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        clearTimeout(this.showTimer);
        this.showTimer = setTimeout(() => {
          if (this.testMode || this.shouldShowBanner()) this.show();
        }, delay * 1000);
    
        if (this.acceptButton) this.on(this.acceptButton, 'click', this.acceptPolicy.bind(this));
        if (this.declineButton) this.on(this.declineButton, 'click', this.declinePolicy.bind(this));
      }
    
      acceptPolicy() {
        this.saveConsent(true);
      }
    
      declinePolicy() {
        this.saveConsent(false);
      }

      saveConsent(accepted) {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: accepted,
          marketing: accepted,
          preferences: accepted
        }, this.hide.bind(this));
      }

      onConsentLibraryLoaded(error) {
        if (error || !window.Shopify.customerPrivacy) return;

        if (this.testMode || this.shouldShowBanner()) this.load(this.delay);
      }

      disconnectedCallback() {
        clearTimeout(this.showTimer);
        super.disconnectedCallback();
      }
    
      afterHide() {
        super.afterHide();
        document.body.classList.remove('has-cookie-banner');
      }
      
      afterShow() {
        super.afterShow();
        document.body.classList.add('has-cookie-banner');
      }
    }
  );
}
